import { Component, Input, OnInit, inject } from '@angular/core';
import { MtxGridColumn } from '@ng-matero/extensions/grid';
import { SharedService } from '@shared/services/shared.service';
import { INote } from 'app/models/note';
import { NoteService } from 'app/services/notes/note.service';

@Component({
  selector: 'notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class NotesComponent implements OnInit {
  @Input() entityId: number = 0;
  @Input() entityType: string = '';

  public text: string = '';
  public notes: INote[] = [];
  public includeArchived: boolean = false;
  public addingNote: boolean = false;

 public columns: MtxGridColumn[] = [
  {
    header: "Notes",
    field: 'text',
    minWidth: 200
  },
  {
    header: "Archive",
    field: 'archive',
    minWidth: 50,
  }
 ]

  public sharedService = inject(SharedService);
  public noteService = inject(NoteService);

  ngOnInit(): void {
    this.getNotes(this.includeArchived);
  }

  getNotes(includeArchived: boolean): void {
    this.includeArchived = includeArchived;
    this.noteService.getNotes(this.entityId, this.entityType, includeArchived).subscribe({
      next: response => this.notes = response,
      error: e => console.log('error retrieving notes', e)
    });
  }

  toggleNoteForm(adding: boolean): void {
    this.addingNote = adding;
    if(!adding){
      this.text = '';
    }
  }

  createNote(): void {
    this.noteService.createNote(this.text, this.entityId, this.entityType).subscribe({
      next: response => {
        this.notes.push(response);
        this.toggleNoteForm(false);
      },
      error: e => {
        this.sharedService.toastr.error("Could not create note");
        console.log('error creating note', e);
      }
    });
  }

  archiveNote(note: INote, archive: boolean): void {
    let archiving: string = archive? 'Archive ' : 'Un-Archive ';
    this.sharedService.openConfirm(archiving + 'this note?');
    this.sharedService.confirmed().subscribe(
      confirmed => {
        if(confirmed){
          this.noteService.archiveNote(note.id, archive).subscribe({
            complete: () => {
              if(archive){
                this.notes = this.notes.filter(n => n.id !== note.id);
              }
            },
            error: e => {
              this.sharedService.toastr.error("Could not archive note");
              console.log('error archiving note', e);
            }
          });
        }
    });
  }
}
